<template>
  <md-card
    :id="`batch-card-${cardType}-${index}`"
    class="batch-card"
    :class="[`batch-card-${cardType}`, `batch-card-${batch.source}`]"
  >
    <md-card-header :id="`card-${cardType}-${index}`">
      <md-card-header-text>
        <card-header
          :barcode="batch?.barcode"
          :index="index"
          :total-samples="batch?.total_samples"
          :label="batch?.label"
          :sequence="batch?.sequence"
          :creation-date="batch?.created_at"
          :collection-place-name="batch?.collectionPoint"
        />

        <div class="batch-card__icons-wrap">
          <card-packaging-icon
            :index="index"
            :packaging-id="batch?.packagingId"
          />

          <CardAdditionalInformationIcon
            v-if="batch?.urgent"
            type="urgent"
            :index="index"
          />
        </div>
      </md-card-header-text>
    </md-card-header>

    <hr
      :id="`batch-card-separator-${index}`"
      class="batch-card-separator"
    >

    <div class="batch-card-icons-container">
      <card-show-details
        :id="batch.id ?? batch.batchIdentifier"
        :index="index"
        :is-details-mode="isDetailsMode"
        :order-by="orderPrintBy"
      />

      <document-icon
        v-if="batch?.docRequired"
        :is-document-delivered="batch?.doc_delivered"
        @click.native="pushToDocumentPendings()"
      />
    </div>

    <md-card-content :id="`batch-card-general-status-${index}`">
      <card-body :batch="batch" />
    </md-card-content>

    <md-card-actions
      v-if="buttonsVisible"
      :id="'batch-card-actions-' + index"
    >
      <card-actions
        :batch="batch"
        :index="index"
      />
    </md-card-actions>

    <card-sort-combo
      v-if="isAOL && !isDetailsMode && !batch?.isPrinted"
      :label-selected="batch?.printSortSelected?.label"
      :index="index"
      @change="handleChangePrintSort"
    />
  </md-card>
</template>

<script>
import { mapGetters } from 'vuex'

import mixin from '@/components/PrintLabels/Batches/BatchesMixin'
import CardHeader from '@/components/PrintLabels/Batches/Cards/Components/CardHeader'
import CardPackagingIcon from '@/components/PrintLabels/Batches/Cards/Components/CardPackagingIcon'
import CardShowDetails from '@/components/PrintLabels/Batches/Cards/Components/CardShowDetails'
import CardBody from '@/components/PrintLabels/Batches/Cards/Components/CardBody'
import CardSortCombo from '@/components/PrintLabels/Batches/Cards/Components/CardSortCombo'
import CardActions from '@/components/PrintLabels/Batches/Cards/Components/CardActions'
import DocumentIcon from '@/components/Documents/Laboratory/Flag'

import CardAdditionalInformationIcon from './Components/CardAdditionalInformationIcon'
import batch from '../../../../store/modules/batch'

export default {
  name: 'BatchCard',
  components: {
    CardHeader,
    CardPackagingIcon,
    CardShowDetails,
    CardBody,
    CardSortCombo,
    CardActions,
    CardAdditionalInformationIcon,
    DocumentIcon
  },
  mixins: [mixin],
  props: {
    batch: {
      type: Object
    },
    isDetailsMode: {
      type: Boolean
    },
    eyeIconVisible: {
      type: Boolean,
      default: true
    },
    buttonsVisible: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      orderPrintBy: 'os_lis'
    }
  },
  computed: {
    ...mapGetters([
      'batchesCurrentTab',
      'profile'
    ]),
    cardType() {
      return this.batch.isPrinted ? 'printed' : 'unprinted'
    },
    isAOL() {
      return this.batch.source === 'AOL2'
    }
  },
  watch: {
    '$route.fullPath'() {
      this.$forceUpdate()
    }
  },
  methods: {
    pushToDocumentPendings() {
      this.$router.push('/documentos-obrigatorios')
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Lote',
        action: 'Filtrar amostras do lote com documentos pendentes',
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    handleChangePrintSort(option) {
      this.orderPrintBy = option?.value
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.batch-card {
  background-color: #fff;
  box-shadow: none;
  border-radius: 6px;
  display: flex;
  padding: 18px 15px;
  overflow: visible;
  transition: all 0.5s ease-out;
  z-index: auto;
  min-width: 252px;
  margin: 0 auto;
  font-family: 'Exo 2';

  &-icons-container {
    display: flex;
  }

  &__icons-wrap {
    display: flex;
    flex-direction: column;
  }

  .document-flag-container {
    margin: 0.2em 0 0 auto;
  }

  &-separator {
    background-color: #7a7a7a;
    height: 0.11em;
    opacity: 0.9;
  }

  .md-card {
    &-actions {
      display: flex;
      flex-wrap: wrap;
      padding: 0;
    }

    &-header {
      display: flex;
      padding: 0;

      .md-card-media {
        display: flex;
        flex: 0;
        justify-content: center;
        top: 12px;
      }

      @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
        /* IE10+ */
        .md-card-media {
          flex: 0 0 auto;
          width: auto !important;
        }
      }
    }

    &-header-text {
      display: flex;
    }

    &-content {
      color: #7a7a7a;
      margin: auto;
      padding: 0;
      line-height: normal;
      letter-spacing: 0.4px;
      text-align: center;

      .batch-card-separator {
        margin: 4px 30%;
        background-color: #ebebeb;
        height: 1px;
        border: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}
</style>
